import React from "react"; 

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import style from './styles.module.css'
import Button from '@material-ui/core/Button'
import ConfBanner from './confBanner/ConfBanner'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
// import LocationCityIcon from '@material-ui/icons/LocationCity';
// import InputRoundedIcon from '@material-ui/icons/InputRounded';
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom' 
import CircularProgress from '@material-ui/core/CircularProgress'
import TopBar from "../utils/Topbar/TopBar.js";
import {connect} from 'react-redux'
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";
import {updateBanner,deleteBanner, getBanner} from './Banner.api'
import { useEffect, useState } from 'react';
import { imageBaseUrl } from '../../config/keys';
const Banner = (props) => { 
  const [data,setData] = useState([])
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")
  const [selectValue,setSelectValue] = React.useState("ALL")
  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activeBanner, setActiveBanner] = React.useState(false) 


  useEffect(() => {
    fetchBanner()
  },[]);

  useEffect(() => {
    if (searchValue) {
      SearchBannerData(searchValue)
    }
    else {
      fetchBanner()
    }
  },[searchValue,selectValue])

  const fetchBanner = () => {
    setData(false);
    getBanner()
      .then(res => {
        if(res.success) {
          setData(res.data);  
          setFilteredData(res.data);
        } else {
          setFilteredData ('NO_DATA');
        }
    }).catch(err => {
      console.log(err)
    });
  }
const SearchBannerData = (Searchid) => {
  // SearchBanner(Searchid)
  //   .then(res => {
  //       if(res.status) {
  //           setData(res.data.qas)  
  //           setFilteredData(res.data.qas)
  //       } else { 
  //           setAlert(res.error)
  //           setFilteredData()
  //       }  
  //   }).catch(err => {
  //     console.log(err)
  //   });
  }
  const handleUpdateStatus = (value,status) => {
    let statusToUpdate = status == "Active" ? 'Inactive':'Active';
    console.log('value:'.value);
    updateBanner(value,statusToUpdate)
    .then(res => {
      setAlert("Updated Successfully")
      fetchBanner();
    }).catch(err => {
      setAlert("Something went wrong");
    }) 
  }
  const handleDelete = (value) => {
   deleteBanner(value.id)
    .then(res => {
      setAlert("Deleted Successfully")
      fetchBanner();
    }).catch(err => {
      setAlert("Something went wrong");
    })
  }
  const isLoading = !filteredData;
  const noData = filteredData == "NO_DATA";
  const showData = !isLoading && !noData;
  const details = [];

  
  !isLoading && filteredData != "NO_DATA" && filteredData.forEach(val => {
    details.push(
      [
        val.question,
        val.answer,
        val.status,
        <React.Fragment>  
          <IconButton onClick={() => {
            setActiveBanner(val)
            setEditModal(true)
          }}>
            <EditRoundedIcon />
          </IconButton>
          
          <ConfirmAlert msg={`Are you sure you want delete ?`} onClickEvent={() => handleDelete(val)}> 
            <IconButton>
              <DeleteRoundedIcon />
            </IconButton>
          </ConfirmAlert>
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      
      <ConfBanner
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          fetchBanner()
        }}
        setAlert={(msg) => setAlert(msg)}
      />
      {activeBanner && <ConfBanner 
        type="EDIT"
        banner={activeBanner} 
        open={editModal} 
        onClose={() => setEditModal(false)} 
        onDone={() => {
          setEditModal(false)
         fetchBanner()
        }} 
        setAlert={(msg) => setAlert(msg)}
      />} 
 
      <Snackbar open={alert} handleClose={() => setAlert(false)}/>
 
      <TopBar 
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)}  
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>Banner</h4> 

              <div className={style.buttons}> 
                <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Banner</Button>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading && 
              <div className={style.loader}>
              <CircularProgress />
              </div>
            }
            {noData &&
                <div className={style.loader}>
                    <h5>No Data Found</h5>
                </div>
            }
            {showData && data !== false && data != null &&
               <>  
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gridGap: 20,paddingRight:10,paddingLeft:10 }}>
                      { data.map((item) => (
                        <div id={item.id}>
                           <img 
                            style={{objectFit:'contain',width:'270px',maxHeight:'156px',height:'156px'}} 
                            src={(imageBaseUrl + item.image_url)}
                            alt="new"
                            />
                            <div style={{fontWeight:'bold',width:'270px',backgroundColor:'gray',paddingLeft:5}}>
                                <h6 style={{display:'inline'}}>
                                  Type:{item.type}&nbsp;&nbsp;&nbsp;&nbsp;Status:{item.status}
                                </h6>
                                <h6 style={{display:'inline',marginLeft:'5%'}}>
                                  <ConfirmAlert msg={`Are you sure you want change status to ${item.status == 'Active' ? 'Inactive':'Active'}?`} onClickEvent={() => handleUpdateStatus(item._id,item.status)}> 
                                    <IconButton>
                                      <DeleteRoundedIcon />
                                    </IconButton>
                                  </ConfirmAlert>
                                </h6>  
                            </div>
                        </div>
                      ))}
                  </div>
               </>
            } 
               {/* <Table
                 tableHeaderColor="primary"
                 tableHead={["Question","Answer","Status","Action"]}
                 tableData={details}
               /> */}
            
            
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

const mapStateToProps = state => ({
  banner: state.appReducer.banner,
})
export default withRouter(connect(mapStateToProps)(Banner));